<script setup lang="ts">
  import { ref } from 'vue';

  import BvBtn from '@bv/components/form/button/BvBtn.vue';
  import BvIcon from '@bv/components/icon/BvIcon.vue';
  import BvMenu from '@bv/components/menu/BvMenu.vue';

  import BvDialPad from './BvDialPad.vue';

  const menu = ref<boolean>(false);

  const phone = ref<string>('');
</script>

<template>
  <bv-menu
    v-model="menu"
    :close-on-content-click="false"
    location="bottom end"
    offset="8"
  >
    <template #activator="{ props }">
      <bv-btn
        class="h-10 max-w-10"
        color="currentColor"
        variant="text"
        v-bind="props"
      >
        <bv-icon
          icon="bvi-call"
          size="lg"
        />
      </bv-btn>
    </template>
    <bv-dial-pad
      v-model="phone"
      class="rounded-lg border border-gray-100 bg-white p-4 shadow-lg"
      @on-call="menu = false"
    />
  </bv-menu>
</template>
